import React, { useState } from "react";
import "./EstimatorCalculator.css";
import { FiDownload } from "react-icons/fi";
import { calculateEstimatorResult, formatValue } from "./calculatorLogic";
import { downloadEstimatorPdf } from "./pdfGenerator";

const EstimatorCalculator = () => {
  const [form, setForm] = useState({
    height: "",
    width: "",
    frameType: "single",
    boardSides: "one",
  });
  const [result, setResult] = useState({
    area: 0,
    unit: "m²",
    Board: 0,
    Screws: 0,
    Screws25: 0,
    Screws35: 0,
    CW: 0,
    UD: 0,
    Filler: 0,
    WaferHead: 0,
    Anchors: 0,
    Tape: 0,
    calculated: false,
  });

  const handleChange = (field) => (event) => {
    const { value } = event.target;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleCalculate = () => {
    setResult(calculateEstimatorResult(form));
  };

  const handleDownloadPdf = async () => {
    await downloadEstimatorPdf({ form, result });
  };

  return (
    <section className="estimator-calc">

      {/* TOP HEADER */}
      <div className="estimator-header">
        <span className="badge">CALCULATOR</span>

        <h1>
          Drywall <span>Estimator</span>
        </h1>

        <p>Plan smarter before your project begins.</p>
      </div>

      {/* MAIN CONTENT */}
      <div className="estimator-grid">

        {/* LEFT PANEL */}
        <div className="calc-box">
          <h3>Calculate area</h3>

          <input
            type="number"
            min="0"
            placeholder="Height (m)"
            value={form.height}
            onChange={handleChange("height")}
          />

          <input
            type="number"
            min="0"
            placeholder="Width (m)"
            value={form.width}
            onChange={handleChange("width")}
          />

          <select value={form.frameType} onChange={handleChange("frameType")}>
            <option value="single">Single Frame</option>
            <option value="double">Double Frame</option>
          </select>

          <select value={form.boardSides} onChange={handleChange("boardSides")}>
            <option value="one">One board each side</option>
            <option value="two">Two board each side</option>
          </select>

          <button className="calculate-btn" onClick={handleCalculate} type="button">
            Calculate
          </button>

          <p className="note">
            Please note: The results provided in this estimate are approximate and may vary by ±10% depending on site conditions and installation practices.
          </p>

          <p className="callback">
            Still not sure how calculation works?{" "}
            <span>Request a call back</span>
          </p>
        </div>

        {/* RIGHT PANEL */}
        <div className="result-box">
          <div className="result-header">
            <span>Description</span>
            <span>Amount</span>
          </div>

          <div className="result-row">
            <span>Total {result.unit}</span>
            <span>{formatValue(result.area, 0)} {result.unit}</span>
          </div>

          <div className="result-row">
            <span>Gypsum Board 1,200x2400mm (1,2x2.4m)</span>
            <span>{result.Board} pcs</span>
          </div>

          <div className="result-row">
            <span>Metal Profile Track (UD)</span>
            <span>{formatValue(result.UD, 0)} m</span>
          </div>

          <div className="result-row">
            <span>Metal Profile Stud (CW)</span>
            <span>{formatValue(result.CW, 0)} m</span>
          </div>

          <div className="result-row">
            <span>Joint Tape</span>
            <span>{formatValue(result.Tape, 0)} m</span>
          </div>

          <div className="result-row">
            <span>Joint Compound</span>
            <span>{formatValue(result.Filler, 0)} kg</span>
          </div>

          <div className="result-row">
            <span>Drywall Screws (M3.5x25 mm)</span>
            <span>{formatValue(result.Screws25, 0)} pcs</span>
          </div>

          {form.boardSides === "two" && (
            <div className="result-row">
              <span>Drywall Screws (M3.5x35 mm)</span>
              <span>{formatValue(result.Screws35, 0)} pcs</span>
            </div>
          )}

          <div className="result-row">
            <span>Wafer Head Screw</span>
            <span>{formatValue(result.WaferHead, 0)} pcs</span>
          </div>

          <div className="result-row">
            <span>Anchors</span>
            <span>{formatValue(result.Anchors, 0)} pcs</span>
          </div>

          <div className="result-row">
            <span>Stud Spacing</span>
            <span>600 mm</span>
          </div>

          <div className="result-row">
            <span>Waste</span>
            <span>5-10%</span>
          </div>

          {!result.calculated && <p className="result-hint">Fill fields and click Calculate to preview results.</p>}
        </div>

      </div>

      {/* DOWNLOAD BUTTON */}
      <div className="download-wrapper">
        <button
          className="download-btn buttongyp"
          type="button"
          onClick={handleDownloadPdf}
          disabled={!result.calculated}
        >
          Download in PDF
          <FiDownload />
        </button>
      </div>

    </section>
  );
};

export default EstimatorCalculator;